import React, { FC } from "react"

interface Props {
    onClick?: () => void
    Icon: React.ElementType
    label: string
    className?: string
    testId?: string
}

export const JobActionButton: FC<Props> = ({
    onClick,
    Icon,
    label,
    className,
    testId
}) => {
    return (
        <button
            data-testid={testId}
            className={
                "leading-none p-2 mr-1 flex items-center whitespace-no-wrap text-rhino-900 hover:bg-smoke-200 rounded-md " +
                className
            }
            onClick={onClick}
        >
            <>
                <Icon className="mr-1.5 w-4 h-4 flex-shrink-0 text-marketplace-pill" />
                {label}
            </>
        </button>
    )
}
